import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=2382815c&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style0 from "./gift.vue?vue&type=style&index=0&id=2382815c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports